import { Heading, Panel, PanelBody, PanelSet } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../types';
import { LogoSettings } from './LogoSettings';
import { ModesPanel } from './ModesPanel';
import { SidebarPanel } from './SidebarPanel';
import { StylingPanel } from './StylingPanel';
import { ThemesPanel } from './ThemesPanel';
import { IconSettings, TitleSettings } from './TitleIconSettings';

/**
 * Tab "General" in the customization flow including all new theme customization options
 */
export function TabGeneral(
    props: SitesCustomizationPanelProps & {
        siteSpaceId?: string;
        siteSpaceName?: string;
    }
) {
    return (
        <PanelSet>
            {
                // Customizing the title of a variant is handled in site structure.
                // For existing site space customizations that already have a favicon or logo, we need to show the UI
                // to allow users to remove them.
                props.siteSpaceId &&
                !props.settings.favicon &&
                !props.settings.header.logo ? null : (
                    <Panel>
                        <Heading>Basic</Heading>
                        <PanelBody>
                            <TitleSettings
                                {...props}
                                siteSpaceId={props.siteSpaceId}
                                siteSpaceName={props.siteSpaceName}
                            />
                            <IconSettings {...props} />
                            <LogoSettings {...props} />
                        </PanelBody>
                    </Panel>
                )
            }
            <ThemesPanel {...props} />
            <ModesPanel {...props} />
            <StylingPanel {...props} />
            <SidebarPanel {...props} />
        </PanelSet>
    );
}
